import React from "react";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import SvgIcon from "../../../../parts/SvgIcon";

class SelectedMembers extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      athletes,
      toggleAthlete,
      toggleShowUnselectedMemberForMobile,
      theme,
    } = this.props;

    // Definición de DesktopHeader y MobileHeader
    const DesktopHeader = (
      <header className="force-mobile-hidden">
        <p className="s1">Members of Group</p>
      </header>
    );

    const MobileHeader = (
      <header className="force-only-show-mobile">
        <div>
          <p>Members of Group</p>
          <p className="number-athletes">({athletes.length})</p>
        </div>
        {athletes.length > 0 && (
          <button onClick={toggleShowUnselectedMemberForMobile}>
            <span className="add-member-button clipped">Add Member</span>
          </button>
        )}
      </header>
    );

    return (
      <div className="members-list">
        {DesktopHeader}
        {MobileHeader}
        {athletes.length > 0 && (
          <ul>
            {athletes.map((elem, index) => {
              return (
                <li
                  key={elem._id || index}
                  onClick={() => toggleAthlete(index)}
                >
                  <img src={getAvatarUrl(elem, true, theme, true)} />
                  <span>{elem.name}</span>
                  <SvgIcon
                    src="/img/new-icons/cross.svg"
                    role="button"
                    data-button-type="text-white"
                    data-icon-only="true"
                  />
                </li>
              );
            })}
          </ul>
        )}
        {athletes.length === 0 && (
          <div className="list-no-members">
            <p>
              <strong>No members</strong>
            </p>
            <p>Select members from the list to add them to this group.</p>
            <button
              className="only-show-mobile"
              onClick={toggleShowUnselectedMemberForMobile}
            >
              <span className="add-member-button clipped">Add Member</span>
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default SelectedMembers;
